import React from 'react';
import './style.scss';

export default function LilHeads({ content }) {
  let mX = 0;
  let mWidth = 0;
  const lilHeads: JSX.Element[] = [];

  if (content && content.RawData && content.RawData.last_few_guys && content.RawData.last_few_guys.length > 0) {
    for (var p = 0; p < content.RawData.last_few_guys.length; p++) {
      const aImage = content.RawData.last_few_guys[p].user_icon;
      const lilHeadStyles = {
        backgroundImage: 'url(' + App.INSTANCE.getImageSrc(aImage) + ')',
        left: mX,
      };

      const aHead = <div className="lil_head cover" style={lilHeadStyles} key={p}></div>;
      mX += 18;
      mWidth += 18;
      lilHeads.push(aHead);
    }
    mWidth += 20;
  }

  return lilHeads.length ? (
    <div className="lil_heads" style={{ width: mWidth }}>
      {lilHeads}
    </div>
  ) : null;
}
